export default __webpack_public_path__ + "static/media/Bank transfer.a729f73c.svg";